import {
  Add,
  CameraAlt,
  Close,
  Edit,
  Visibility,
  VisibilityOff,
} from "@mui/icons-material";
import {
  Autocomplete,
  Avatar,
  Badge,
  Box,
  Button,
  Card,
  CardContent,
  Chip,
  createTheme,
  Dialog,
  Divider,
  IconButton,
  LinearProgress,
  Link,
  List,
  ListItemButton,
  ListItemText,
  Stack,
  Tab,
  Tabs,
  Tooltip,
  TextField,
  Typography,
  Zoom,
  ListItem,
  Collapse,
} from "@mui/material";
import { useContext, useEffect, useState } from "react";
import { blue, green, grey } from "@mui/material/colors";
import less_work from "../../images/images/less_work.jpg";
import { DataContext } from "../InitHrm";
import { useFormik } from "formik";
import * as Yup from "yup";
import LoadingButton from "@mui/lab/LoadingButton";
import axios from "axios";
import { BaseHrmUrl } from "../../Intro/Constants";

const theme = createTheme({
  palette: {
    primary: {
      light: blue[300],
      main: blue[500],
      dark: blue[700],
    },
    white: grey[10],
  },
});

const Opportunities = [
  { title: "Opportunities applied", value: 10 },
  { title: "Opportunities won", value: 5 },
  { title: "Current opportunities", value: 3 },
];

function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
    </div>
  );
}

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

function Company() {
  const state = useContext(DataContext);
  const [value, setValue] = useState(0);
  const [openMpesa, setOpenMpesa] = useState(false);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <Zoom in={true} style={{ transitionDelay: "200ms" }}>
      <Stack>
        <Card sx={{ minHeight: "103vh" }}>
          <CardContent>
            <Box bgcolor={blue[300]} height={"30vh"} padding={2}>
              <Box display={"flex"} justifyContent={"end"}>
                <Button
                  variant={"outlined"}
                  color="success"
                  sx={{ ml: "auto", borderRadius: 4 }}
                  startIcon={<CameraAlt />}
                >
                  change cover
                </Button>
              </Box>
            </Box>
            <Box display={"flex"} mt={-5} padding={3} columnGap={2}>
              <Card sx={{ width: "20vw" }}>
                <CardContent>
                  <Box display={"flex"} justifyContent={"center"}>
                    <Badge
                      overlap="circular"
                      anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
                      badgeContent={
                        <IconButton
                          color="info"
                          sx={{ border: `2px solid ${grey[50]}` }}
                          size="small"
                        >
                          <CameraAlt color="info" />
                        </IconButton>
                      }
                    >
                      <Avatar
                        src={less_work}
                        alt="profile"
                        sx={{ width: 96, height: 96 }}
                      ></Avatar>
                    </Badge>
                  </Box>
                  <Box
                    display={"flex"}
                    flexDirection={"column"}
                    justifyContent={"center"}
                    alignItems={"center"}
                  >
                    <Typography variant={"body1"} sx={{ fontWeight: "bold" }}>
                      {state.profile.branch.company.company_name}
                    </Typography>
                    <Typography variant={"body2"}>
                      {state.profile.branch.branch_name}
                    </Typography>
                  </Box>
                  <Stack>
                    <List>
                      {Opportunities.map((oppo) => {
                        return (
                          <ListItemButton>
                            <Box display={"flex"}>
                              <Typography>
                                {oppo.title}{" "}
                                {
                                  <Chip
                                    label={oppo.value}
                                    color="info"
                                    size="small"
                                  />
                                }
                              </Typography>
                            </Box>
                          </ListItemButton>
                        );
                      })}
                    </List>
                    <Divider />
                    <Box
                      display={"flex"}
                      flexDirection={"column"}
                      justifyContent={"center"}
                      alignItems={"center"}
                    >
                      <Link href="https://www.kadesea.co.ke" underline="hover">
                        View Site
                      </Link>
                    </Box>
                  </Stack>
                  <Box display={"flex"} justifyContent={"center"}>
                    <Button
                      variant="contained"
                      sx={{ borderRadius: 4 }}
                      onClick={() => setOpenMpesa(!openMpesa)}
                      color="success"
                    >
                      mpesa
                    </Button>
                  </Box>
                  <Collapse in={openMpesa} timeout="auto" unmountOnExit>
                    <Stack rowGap={1} mt={1}>
                      <TextField label="Paybill" size="small" />
                      <TextField label="Account number" size="small" />
                      <Button
                        variant="outlined"
                        sx={{ borderRadius: 4 }}
                        onClick={() => setOpenMpesa(!openMpesa)}
                      >
                        save
                      </Button>
                    </Stack>
                  </Collapse>
                </CardContent>
              </Card>
              <Card
                sx={{
                  width: "63vw",
                }}
              >
                <CardContent>
                  <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
                    <Tabs
                      value={value}
                      onChange={handleChange}
                      aria-label="basic tabs"
                    >
                      <Tab label="Profile Settings" {...a11yProps(0)} />
                      <Tab label="Company Settings" {...a11yProps(1)} />
                      <Tab label="Structure" {...a11yProps(2)} />
                      <Tab label="Billing" {...a11yProps(3)} />
                      <Tab label="Accounts" {...a11yProps(4)} />
                    </Tabs>
                  </Box>
                  <CustomTabPanel value={value} index={0}>
                    <AccountSettings />
                  </CustomTabPanel>
                  <CustomTabPanel value={value} index={1}>
                    <CompanySettings />
                  </CustomTabPanel>
                  <CustomTabPanel value={value} index={2}>
                    <Structure />
                  </CustomTabPanel>
                  <CustomTabPanel value={value} index={3}>
                    <Billing />
                  </CustomTabPanel>
                  <CustomTabPanel value={value} index={4}>
                    <Banking />
                  </CustomTabPanel>
                </CardContent>
              </Card>
            </Box>
          </CardContent>
        </Card>
      </Stack>
    </Zoom>
  );
}

export default Company;

function AccountSettings() {
  const context = useContext(DataContext);

  const myFormik = useFormik({
    initialValues: {
      first_name: context.profile.user.first_name,
      last_name: context.profile.user.last_name,
      middleName: "",
      nickName: "",
      email: context.profile.user.email,
      primary_phone: context.profile.primary_phone,
      secondaryPhone: "",
      company: context.profile.branch.company.company_name,
      title: "",
      street: "",
      poBox: "",
      city: context.profile.town,
      county: context.profile.county,
      website: "",
      birthday: null,
      label: "",
      edit: false,
    },

    validationSchema: Yup.object({
      userName: Yup.string()
        .required("Required")
        .min(3, "must be more than 3 characters"),
      firstName: Yup.string()
        .required("Required")
        .min(3, "must be more than 3 characters"),
      middleName: Yup.string().min(3, "must be more than 3 characters"),
      lastName: Yup.string()
        .required("Required")
        .min(3, "must be more than 3 characters"),
      email: Yup.string()
        .email()
        .matches(/^[a-z].+@./, "Invalid email"),
      primaryPhone: Yup.string()
        .required("Required")
        .min(10, "Invalid phone number")
        .max(13, "Invalid phone number")
        .matches(/^[0+]/, "Invalid phone number"),
    }),

    onSubmit: (values) => {},
  });

  return (
    <Zoom in={true} style={{ transitionDelay: "200ms" }}>
      <form onSubmit={myFormik.handleSubmit}>
        <Stack>
          <Box display={"flex"} alignItems={"center"}>
            <Stack width={"50%"} padding={1}>
              <Stack>
                <Typography>First name</Typography>
                <TextField
                  size="small"
                  name="first_name"
                  id="first_name"
                  value={myFormik.values.first_name}
                  onChange={myFormik.handleChange}
                  onBlur={myFormik.handleBlur}
                />
              </Stack>
              <Stack mt={1}>
                <Typography>Phone number</Typography>
                <TextField
                  size="small"
                  name="primary_phone"
                  id="primary_phone"
                  value={myFormik.values.primary_phone}
                  onChange={myFormik.handleChange}
                  onBlur={myFormik.handleBlur}
                />
              </Stack>
              <Stack mt={1}>
                <Typography>Town</Typography>
                <TextField
                  size="small"
                  name="city"
                  id="city"
                  value={myFormik.values.city}
                  onChange={myFormik.handleChange}
                  onBlur={myFormik.handleBlur}
                />
              </Stack>
              <Stack mt={1}>
                <Typography>Postal code</Typography>
                <TextField
                  size="small"
                  name="poBox"
                  id="poBox"
                  value={myFormik.values.poBox}
                  onChange={myFormik.handleChange}
                  onBlur={myFormik.handleBlur}
                />
              </Stack>
            </Stack>
            <Stack width={"50%"}>
              <Stack>
                <Typography>Last name</Typography>
                <TextField
                  size="small"
                  name="last_name"
                  id="last_name"
                  value={myFormik.values.last_name}
                  onChange={myFormik.handleChange}
                  onBlur={myFormik.handleBlur}
                />
              </Stack>
              <Stack mt={1}>
                <Typography>Email address</Typography>
                <TextField
                  size="small"
                  name="email"
                  id="email"
                  value={myFormik.values.email}
                  onChange={myFormik.handleChange}
                  onBlur={myFormik.handleBlur}
                />
              </Stack>
              <Stack mt={1}>
                <Typography>County</Typography>
                <TextField
                  size="small"
                  name="county"
                  id="county"
                  value={myFormik.values.county}
                  onChange={myFormik.handleChange}
                  onBlur={myFormik.handleBlur}
                />
              </Stack>
              <Stack mt={1}>
                <Typography>Country</Typography>
                <TextField size="small" />
              </Stack>
            </Stack>
          </Box>
          <Divider />
          <Box display={"flex"} justifyContent={"end"} padding={1}>
            <Button variant="contained" type="submit">
              Update
            </Button>
          </Box>
        </Stack>
      </form>
    </Zoom>
  );
}

function CompanySettings() {
  const context = useContext(DataContext);

  const myForm = useFormik({
    initialValues: {
      company: context.profile.branch.company.company_name,
      branch: context.profile.branch.branch_name,
      contact: context.profile.branch.company.contact,
      email: context.profile.branch.company.email,
      po_box: context.profile.primary_phone,
      town: context.profile.branch.company.town,
      county: context.profile.county,
      country: "",
    },

    validationSchema: Yup.object({
      company: Yup.string()
        .required("Required")
        .min(3, "must be more than 3 characters"),
      branch: Yup.string()
        .required("Required")
        .min(3, "must be more than 3 characters"),
      contact: Yup.string().min(3, "must be more than 3 characters"),
      town: Yup.string()
        .required("Required")
        .min(3, "must be more than 3 characters"),
      email: Yup.string()
        .email()
        .matches(/^[a-z].+@./, "Invalid email"),
      contact: Yup.string()
        .required("Required")
        .min(10, "Invalid phone number")
        .max(13, "Invalid phone number")
        .matches(/^[0+]/, "Invalid phone number"),
    }),

    onSubmit: (values) => {},
  });

  return (
    <Zoom in={true} style={{ transitionDelay: "200ms" }}>
      <Stack>
        <form onSubmit={myForm.handleSubmit}>
          <Box display={"flex"} alignItems={"center"}>
            <Stack width={"50%"} padding={1}>
              <Stack>
                <Typography>Company name</Typography>
                <TextField
                  size="small"
                  name="company"
                  id="company"
                  disabled={true}
                  value={myForm.values.company}
                  onChange={myForm.handleChange}
                  onBlur={myForm.handleBlur}
                />
              </Stack>
              <Stack mt={1}>
                <Typography>Branch</Typography>
                <TextField
                  size="small"
                  name="branch"
                  id="branch"
                  value={myForm.values.branch}
                  onChange={myForm.handleChange}
                  onBlur={myForm.handleBlur}
                />
              </Stack>
              <Stack mt={1}>
                <Typography>Primary phone number</Typography>
                <TextField
                  size="small"
                  name="contact"
                  id="contact"
                  value={myForm.values.contact}
                  onChange={myForm.handleChange}
                  onBlur={myForm.handleBlur}
                />
              </Stack>
              <Stack mt={1}>
                <Typography>Postal code</Typography>
                <TextField
                  size="small"
                  name="po_box"
                  id="po_box"
                  value={myForm.values.po_box}
                  onChange={myForm.handleChange}
                  onBlur={myForm.handleBlur}
                />
              </Stack>
            </Stack>
            <Stack width={"50%"}>
              <Stack>
                <Typography>Email address</Typography>
                <TextField
                  size="small"
                  name="email"
                  id="email"
                  value={myForm.values.email}
                  onChange={myForm.handleChange}
                  onBlur={myForm.handleBlur}
                />
              </Stack>
              <Stack mt={1}>
                <Typography>Town</Typography>
                <TextField
                  size="small"
                  name="town"
                  id="town"
                  value={myForm.values.town}
                  onChange={myForm.handleChange}
                  onBlur={myForm.handleBlur}
                />
              </Stack>
              <Stack mt={1}>
                <Typography>County</Typography>
                <TextField
                  size="small"
                  name="county"
                  id="county"
                  value={myForm.values.county}
                  onChange={myForm.handleChange}
                  onBlur={myForm.handleBlur}
                />
              </Stack>
              <Stack mt={1}>
                <Typography>Country</Typography>
                <TextField size="small" disabled={true} />
              </Stack>
            </Stack>
          </Box>
          <Divider />
          <Box display={"flex"} justifyContent={"end"} padding={1}>
            <Button variant="contained" type="submit">
              Update
            </Button>
          </Box>
        </form>
      </Stack>
    </Zoom>
  );
}

function Structure() {
  const state = useContext(DataContext);
  const [departments, setDepartments] = useState(null);
  const [allData, setAllData] = useState(null);
  const [sections, setSections] = useState(null);
  const [message, setMessage] = useState(null);
  const [loadDpt, setLoadDpt] = useState(false);
  const [loadSect, setLoadSect] = useState(false);

  const [openDepart, setOpenDepart] = useState(false);
  const [openSect, setOpenSect] = useState(false);
  const key = state.token;
  const myDepart = useFormik({
    initialValues: {
      key: state.token,
      department: "",
      section: "",
      salary: "",
    },

    validationSchema: Yup.object({
      department: Yup.string()
        .required("Required")
        .min(3, "at least 3 characters"),
      section: Yup.string()
        .required("Required")
        .min(2, "at least 2 characters"),
      salary: Yup.number().moreThan(-1, "salary can not be negative"),
    }),

    onSubmit: (values) => {
      //start loading btn
      setLoadDpt(true);
      async function postData(values) {
        
        try {
          const response = await axios.post(
            `${BaseHrmUrl}/department`,
            { ...values },
            {
              headers: {
                "Content-Type": "application/x-www-form-urlencoded",
              },
            }
          );
    
          if (response.status === 200) {
            setLoadDpt(false);
            setOpenDepart(false);
            alert("Department added successfully");
          } else {
            setLoadDpt(false);
            setOpenDepart(false);
            setMessage(response.data.message);
            alert(message);
          }
        } catch (error) {
          setLoadDpt(false);
          alert("Error trying to fetch, No Internet?");
        }
      }
      
      postData(values);
    },
  });
  const handleDeptClick = (dept) => {
    const allSections = allData.filter((data) => {
      if (data.department.department !== dept) {
        return false;
      } else {
        return true;
      }
    });
    setSections(allSections);
  };
  useEffect(() => {
    if (allData) {
      const deps = allData.map((data) => {
        return data.department.department;
      });

      const set = new Set(deps);
      const departs = Array.from(set);
      setDepartments(departs);
    }
  }, [allData]);

  useEffect(() => {
    async function postData() {
      try {
        const response = await axios.post(
          `${BaseHrmUrl}/section`,
          { key: key,
            company: state.profile.branch.company.company_name,
            branch: state.profile.branch.branch_name, },
          {
            headers: {
              "Content-Type": "application/x-www-form-urlencoded",
            },
          }
        );
  
        if (response.status === 200) {
          setAllData(response.data);
        } 
      } catch (error) {
        
        alert("Error trying to fetch, No Internet?");
      }
    }
   
    postData();
  }, []);

  const mySection = useFormik({
    initialValues: {
      department: "",
      section: "",
      salary: "",
    },

    validationSchema: Yup.object({
      section: Yup.string()
        .required("Required")
        .min(2, "at least a characters"),
      salary: Yup.number().moreThan(-1, "salary can not be negative"),
    }),

    onSubmit: (values) => {

      setLoadSect(true);
      async function postData(values) {
        try {
          const response = await axios.post(
            `${BaseHrmUrl}/section/add`,
            { ...values },
            {
              headers: {
                "Content-Type": "application/x-www-form-urlencoded",
              },
            }
          );
    
          if (response.status === 200) {
            setLoadSect(false);
            setMessage(response.data.message);
            setOpenSect(false);
            alert("Section added successfully");
          } else {
            setLoadSect(false);
            setOpenSect(false);
            setMessage(response.data.message);
            alert(message);
          }
        } catch (error) {
          setLoadSect(false);
          setOpenSect(false)
          alert("Error trying to fetch, No Internet?");
        }
      }
     
      postData(values);
    }
      
   
  });

  return (
    <Zoom in={true} style={{ transitionDelay: "200ms" }}>
      <Stack>
        <Box display={"flex"} alignItems={"start"}>
          <Stack
            width={"40%"}
            padding={1}
            borderRight={`1px ${grey[300]} solid`}
          >
            <Box display={"flex"} padding={1} alignItems={"center"}>
              <Typography variant="body1" sx={{ fontWeight: "bold" }}>
                Departments
              </Typography>
              <IconButton
                sx={{ ml: "auto" }}
                onClick={() => setOpenDepart(true)}
              >
                <Add />
              </IconButton>
            </Box>
            <Divider />
            <List>
              {/* {show all departments} */}
              {departments ? (
                departments.map((department) => {
                  return (
                    <ListItemButton
                      onClick={() => handleDeptClick(department)}
                      key={department}
                    >
                      <ListItemText primary={department} />
                    </ListItemButton>
                  );
                })
              ) : (
                <Typography variant="body1">No departments</Typography>
              )}
            </List>
          </Stack>
          <Stack width={"60%"} padding={1}>
            <Box display={"flex"} padding={1} alignItems={"center"}>
              <Typography variant="body1" sx={{ fontWeight: "bold" }}>
                Sections
              </Typography>
              <IconButton sx={{ ml: "auto" }} onClick={() => setOpenSect(true)}>
                <Add />
              </IconButton>
            </Box>
            <Divider />
            <List>
              {/* {show all departments} */}
              {sections ? (
                sections.map((section) => {
                  return (
                    <Box
                      display={"flex"}
                      padding={1}
                      alignItems={"center"}
                      key={section}
                    >
                      <Typography variant="body2">{section.section}</Typography>
                      <Tooltip title="edit" placement="right">
                        <IconButton sx={{ ml: "auto" }}>
                          <Edit />
                        </IconButton>
                      </Tooltip>
                    </Box>
                  );
                })
              ) : (
                <Typography variant="body1">Select Department</Typography>
              )}
            </List>
          </Stack>
        </Box>
        <Dialog
          open={openDepart}
          onClose={() => setOpenDepart(false)}
          fullWidth
          maxWidth="sm"
        >
          <Card elevation={2}>
            <CardContent>
              <Box display={"flex"} alignItems={"center"}>
                <Typography variant="body1" sx={{ fontWeight: "bold" }}>
                  Create Department
                </Typography>
                <IconButton
                  color="error"
                  sx={{ ml: "auto" }}
                  onClick={() => setOpenDepart(false)}
                >
                  <Close />
                </IconButton>
              </Box>
              <Divider />
              <form onSubmit={myDepart.handleSubmit}>
                <Box
                  mt={2}
                  padding={2}
                  display={"flex"}
                  flexDirection={"column"}
                  rowGap={2}
                >
                  <Stack>
                    <TextField
                      size="small"
                      label="Name of department"
                      name="department"
                      id="department"
                      onChange={myDepart.handleChange}
                      value={myDepart.values.department}
                      onBlur={myDepart.handleBlur}
                    />
                    {myDepart.touched.department &&
                    myDepart.errors.department ? (
                      <Typography variant="body2" color="error">
                        {myDepart.errors.department}
                      </Typography>
                    ) : null}
                  </Stack>

                  <Stack>
                    <TextField
                      size="small"
                      label="Name of Section"
                      name="section"
                      id="section"
                      onChange={myDepart.handleChange}
                      value={myDepart.values.section}
                      onBlur={myDepart.handleBlur}
                    />
                    {myDepart.touched.section && myDepart.errors.section ? (
                      <Typography variant="body2" color="error">
                        {myDepart.errors.section}
                      </Typography>
                    ) : null}
                  </Stack>
                  <Stack>
                    <TextField
                      size="small"
                      label="Salary / Wage"
                      name="salary"
                      id="salary"
                      type="number"
                      onChange={myDepart.handleChange}
                      value={myDepart.values.salary}
                      onBlur={myDepart.handleBlur}
                    />
                    {myDepart.touched.salary && myDepart.errors.salary ? (
                      <Typography variant="body2" color="error">
                        {myDepart.errors.salary}
                      </Typography>
                    ) : null}
                  </Stack>
                  <LoadingButton
                    type="sumbit"
                    size="small"
                    variant="outlined"
                    loading={loadDpt}
                  >
                    Create
                  </LoadingButton>
                </Box>
              </form>
            </CardContent>
          </Card>
        </Dialog>
        <Dialog
          open={openSect}
          onClose={() => setOpenSect(false)}
          fullWidth
          maxWidth="sm"
        >
          <Card elevation={2}>
            <CardContent>
              <Box display={"flex"} alignItems={"center"}>
                <Typography variant="body1" sx={{ fontWeight: "bold" }}>
                  Create Section
                </Typography>
                <IconButton
                  color="error"
                  sx={{ ml: "auto" }}
                  onClick={() => setOpenSect(false)}
                >
                  <Close />
                </IconButton>
              </Box>
              <Divider />
              <form onSubmit={mySection.handleSubmit}>
                <Box
                  mt={2}
                  padding={2}
                  display={"flex"}
                  flexDirection={"column"}
                  rowGap={2}
                >
                  <Stack>
                    <Autocomplete
                      disablePortal
                      options={departments}
                      sx={{ width: 300 }}
                      onChange={(ev, val) =>
                        (mySection.values.department = val)
                      }
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label="Departments"
                          size="small"
                          sx={{ borderRadius: 4 }}
                        />
                      )}
                    />
                  </Stack>
                  <Stack>
                    <TextField
                      size="small"
                      label="Section name"
                      name="section"
                      id="section"
                      onChange={mySection.handleChange}
                      value={mySection.values.section}
                      onBlur={mySection.handleBlur}
                    />
                    {mySection.touched.section && mySection.errors.section ? (
                      <Typography variant="body2" color="error">
                        {mySection.errors.section}
                      </Typography>
                    ) : null}
                  </Stack>
                  <Stack>
                    <TextField
                      size="small"
                      label="Salary / Wage"
                      name="salary"
                      id="salary"
                      type="number"
                      onChange={mySection.handleChange}
                      value={mySection.values.salary}
                      onBlur={mySection.handleBlur}
                    />
                    {mySection.touched.salary && mySection.errors.salary ? (
                      <Typography variant="body2" color="error">
                        {mySection.errors.salary}
                      </Typography>
                    ) : null}
                  </Stack>
                  <LoadingButton
                    type="sumbit"
                    size="small"
                    variant="outlined"
                    loading={loadSect}
                  >
                    Create
                  </LoadingButton>
                </Box>
              </form>
            </CardContent>
          </Card>
        </Dialog>
      </Stack>
    </Zoom>
  );
}

function Billing() {
  return (
    <Zoom in={true} style={{ transitionDelay: "200ms" }}>
      <Box display={"flex"}>
        <Stack width={"70%"}>
          <Box display={"flex"} justifyContent={"space-evenly"}>
            <Card elevation={2} sx={{ width: "47%", bgcolor: blue[200] }}>
              <CardContent>
                <Typography variant="body1">
                  Current subscription plan
                </Typography>
                <Typography variant="h5" mt={2}>
                  Ksh 2500.00
                </Typography>
                <Typography variant="body1" mt={2}>
                  Basic Plan
                </Typography>
                <Button
                  size="small"
                  variant="contained"
                  sx={{ mt: 2, justifySelf: "center" }}
                >
                  Change plan
                </Button>
              </CardContent>
            </Card>
            <Card elevation={2} sx={{ width: "47%" }}>
              <CardContent>
                <Typography variant="body1">Next payment</Typography>
                <Typography variant="h5" mt={2}>
                  Ksh 2500.00
                </Typography>
                <Typography variant="body1" mt={2}>
                  on Jan 01 2025
                </Typography>
                <Button
                  size="small"
                  variant="contained"
                  sx={{ mt: 2, justifySelf: "center" }}
                >
                  Manage payments
                </Button>
              </CardContent>
            </Card>
          </Box>
          <Stack>
            <Typography variant="h5" mt={2}>
              Payment history
            </Typography>
            <Divider />
          </Stack>
        </Stack>
        <Stack display={"flex"} width={"30%"} rowGap={2}>
          <Card elevation={2} sx={{ bgcolor: grey[300] }}>
            <CardContent>
              <Box display={"flex"} alignItems={"center"}>
                <Typography variant="body1" sx={{ fontWeight: "bold" }}>
                  Payment information
                </Typography>
                <IconButton sx={{ ml: "auto" }}>
                  <Edit />
                </IconButton>
              </Box>
              <Box display={"flex"} alignItems={"center"} columnGap={2}>
                <Typography variant="body1" sx={{ fontWeight: "bold" }}>
                  Payment Mode
                </Typography>
                <Chip label="Mpesa" />
              </Box>
            </CardContent>
          </Card>
          <Card elevation={2}>
            <CardContent>
              <Typography variant="body1" sx={{ fontWeight: "bold" }}>
                My Location
              </Typography>
              <Divider />
            </CardContent>
          </Card>
          <Card elevation={2}>
            <CardContent>
              <Typography variant="body1" sx={{ fontWeight: "bold" }}>
                Storage
              </Typography>
              <Divider />
              <Box mt={1}>
                <LinearProgress color="info" variant="determinate" value={65} />
              </Box>
              <Button variant="outlined" size="small" sx={{ mt: 2 }}>
                buy storage
              </Button>
            </CardContent>
          </Card>
        </Stack>
      </Box>
    </Zoom>
  );
}

function Banking() {
  const accounts = [
    { id: 1, name: "COOP", balance: 566000 },
    { id: 1, name: "KCB", balance: 566000 },
    { id: 1, name: "SALARIES", balance: 566000 },
    { id: 1, name: "MISC", balance: 566000 },
  ];

  const [details, setDetails] = useState(null);
  const [showBal, setShowBal] = useState(null);

  const handleAddAccount = () => {};

  return (
    <Zoom in={true} style={{ transitionDelay: "200ms" }}>
      <Stack>
        <Typography variant="h6" sx={{ fontWeight: "bold" }}>
          Accounts
        </Typography>
        <Divider variant="middle" />
        <Box
          display={"flex"}
          mt={2}
          columnGap={2}
          justifyContent={"space-evenly"}
        >
          <Stack width={"63%"}>
            <Box display={"flex"} mt={1} columnGap={2} alignItems={"center"}>
              <Typography variant="body1" sx={{ fontWeight: "bold" }}>
                All accounts
              </Typography>
              <Tooltip title="new account">
                <IconButton sx={{ ml: "auto" }} onClick={handleAddAccount}>
                  <Add />
                </IconButton>
              </Tooltip>
            </Box>
            <Divider />
            <Card sx={{ mt: 1 }}>
              <CardContent>
                {accounts ? (
                  <List style={{ maxHeight: "70vh", overflow: "auto" }}>
                    {accounts.map((account) => {
                      return (
                        <ListItem key={account.id}>
                          <ListItemButton
                            sx={{ borderRadius: 4, bgcolor: green[200] }}
                            onClick={() => {
                              setDetails(account);
                            }}
                          >
                            <ListItemText
                              primary={
                                <Box display={"flex"}>
                                  <Typography
                                    variant="body1"
                                    sx={{ fontWeight: "bold" }}
                                  >
                                    {account.name}
                                  </Typography>{" "}
                                  <Chip
                                    sx={{ ml: "auto" }}
                                    label={"current"}
                                    color={"info"}
                                  />{" "}
                                </Box>
                              }
                            />
                          </ListItemButton>
                        </ListItem>
                      );
                    })}
                  </List>
                ) : (
                  <Typography variant="body1" sx={{ fontWeight: "bold" }}>
                    No accounts created yet!
                  </Typography>
                )}
              </CardContent>
            </Card>
          </Stack>
          <Divider flexItem orientation="vertical" />
          <Stack width={"35%"}>
            <Box display={"flex"} mt={1} columnGap={2} alignItems={"center"}>
              <Typography variant="body1" fontWeight={"bold"}>
                Account Details
              </Typography>
            </Box>
            <Divider />
            {details ? (
              <CardContent>
                <Box display={"flex"} justifyContent={"center"}>
                  <Typography variant="body1" fontWeight={"bold"}>
                    {details.name}
                  </Typography>
                </Box>
                <Box display={"flex"} alignItems={"center"}>
                  <Typography variant="body1" fontWeight={"bold"}>
                    Balance{" : "}
                    {showBal ? details.balance : "*********"}
                  </Typography>
                  <IconButton onClick={() => setShowBal(!showBal)}>
                    {showBal ? <VisibilityOff /> : <Visibility />}
                  </IconButton>
                </Box>
                <Button variant="outlined" sx={{ borderRadius: 4 }}>
                  transfer funds
                </Button>
              </CardContent>
            ) : (
              <Typography variant="body1" fontWeight={"bold"}>
                Select an account
              </Typography>
            )}
          </Stack>
        </Box>
      </Stack>
    </Zoom>
  );
}
